import React from "react";
import clsx from "clsx";
import { connect, ConnectedProps } from "react-redux";
import { setSidebarToggleMobile } from "../../reducers/ThemeOptions";
import HeaderUserbox from "../../layout-components/HeaderUserbox";

interface ThemeOptionsState {
  headerShadow: boolean;
  headerBgTransparent: boolean;
  sidebarToggleMobile: boolean;
}
interface RootState {
  ThemeOptions: ThemeOptionsState;
  [key: string]: any;
}

const mapStateToProps = (state: RootState) => ({
  headerShadow: state.ThemeOptions.headerShadow,
  headerBgTransparent: state.ThemeOptions.headerBgTransparent,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = {
  setSidebarToggleMobile
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const Header: React.FC<PropsFromRedux> = ({
  headerShadow,
  headerBgTransparent,
  sidebarToggleMobile,
  setSidebarToggleMobile
}) => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };

  return (
    <div
      className={clsx("app-header", {
        "app-header--shadow": headerShadow,
        "app-header--opacity-bg": headerBgTransparent
      })}
    >
      <div className="app-header--pane">
        <button
          className={clsx(
            "navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn",
            { "is-active": sidebarToggleMobile }
          )}
          onClick={toggleSidebarMobile}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
      </div>
      <div className="app-header--pane">
        {/* <HeaderDots /> */}
        <HeaderUserbox />
      </div>
    </div>
  );
};

export default connector(Header);
